export const getEditIssueTypeUrl = (issueTypeId: string) =>
	`/secure/admin/EditIssueType!default.jspa?id=${issueTypeId}`;

export const getDeleteIssueTypeUrl = (issueTypeId: string) =>
	`/secure/admin/DeleteIssueType!default.jspa?id=${issueTypeId}`;

export const getTranslateIssueTypeUrl = (hierarchyLevel: number) =>
	`/secure/admin/ViewTranslations!default.jspa?issueConstantType=${
		hierarchyLevel < 0 ? 'subTask' : 'issuetype'
	}`;

export const getRelatedSchemeUrl = (schemeId: string, name: string) =>
	`/jira/settings/issues/issue-type-schemes?orderBy=name&pageNumber=1&searchFilter=${name}`;
